/* eslint-disable @typescript-eslint/naming-convention */
export const BASEURL: string = '';

export const CMS_SERVICE_URL: string = '/cms/block/get/blocks/';

export const LAZYLOAD_DEFAULT_IMAGES: { [key: string]: string } = {
    PHONE: '/skin/frontend/angular-2/web/dist/assets/images/lazyload/lazyload-phone-default-image.svg',
};

export const URLS = {
    CART: '/panier',
    CROSS_SELL: '/personnaliser-mon-offre',
    CONTRACTS: '/telephones-mobiles/renouvellement/contrats',
    CONNECTION_ERROR: '/telephones-mobiles/renouvellement/erreur-connexion',
    WALLS: {
        PHONES: '/telephones-mobiles',
        RENEW: '/telephones-mobiles/renouvellement',
        FAIM: '/hotspot-tablette',
        ACCESSORIES: '/accessoires',
        SOLDES: '/bons-plans/soldes',
    },
    PLANS_PAGE: {
        RENEW: '/forfaits-mobiles/renouvellement',
    },
    SHOP: {
        ADD_TO_CART: '/shop/cart/addtocart',
    },
    CATALOG: {
        STANDARD: '/services/catalog/products',
        RENEWAL: '/services/catalog/renewal',
    },
    CARD_TYPE: {
        PHONE: 'Acquisition',
        ACCESSORY: 'Accessory',
        FAIM: 'Faim',
        RENEW: 'Renew',
    },
};

export const WALLS = {
    TYPE: {
        PHONE: 'téléphone',
        RENEW: 'téléphone',
        ACCESSORY: 'accessoire',
        FAIM: 'hotspot',
        SOLDES: 'bon-plan',
    },
    TITLE: {
        PHONE: 'Smartphone / téléphone',
        ACCESSORY: 'Accessoires',
        FAIM: 'Hotspots et tablettes',
        SOLDES: 'Soldes',
    },
};
